import Logo from '../../../react/features/AppHeader/components/Logo';
import NavigationList from '../../../react/features/Navigation/List';
import { useAppContext } from '../../../react/hooks/useAppContext';
import useLocalStorage from '../../../react/hooks/useLocalStorage';
import { isFeatureEnabled } from '../../../react/services/Features';
import Actions from '../../Actions';
import ActionsCompact from '../../ActionsCompact';
import styles from './style.m.less';

export default function Sidebar() {
    const { user } = useAppContext();
    // Preparing for having a default state based on current width
    const [navState, setNavState] = useLocalStorage<'compact' | 'wide' | null>('nav-state', null);
    const isCompact = isFeatureEnabled('FEATURE_navigationCompact') && navState === 'compact';

    return (
        <div className={isCompact ? styles.navigationCompact : styles.navigationWide}>
            <div className={styles.navigationInner} id="mainNavigation">
                <div className={styles.navigationLogo}>
                    <Logo user={user} iconOnly={isCompact} />
                </div>
                <div className={styles.navigationList}>
                    <NavigationList isCompact={isCompact} />
                </div>
                {!isCompact && <Actions onCollapse={() => setNavState('compact')} />}
                {isCompact && <ActionsCompact onExpand={() => setNavState(null)} />}
            </div>
        </div>
    );
}
